import Iats3dsPayerData from "../providers/iats3ds.payerData.js";

// --------------------------------------------
// --                iATS 3DS                --
// --------------------------------------------

export default class Iats3dsController {
    static get endpoint() { return 'https://www.uk.iatspayments.com/netgate/auralinkv4.asmx/PostPaysafe3DS2Authentication'; }
    iats3ds = window.iats3ds;
    clientID;
    card;
    data;
    payerData;
    
    constructor(card, data) {
        this.card = card;
        this.data = data;
        this.clientID = data.IatsAgentCode;
        this.payerData = new Iats3dsPayerData(card, data);
    }

    //
    // Step 1: 
    // Init Authentication & Collect Device Fingerprint ID
    //
    iatsGetFingerPrintId() {

        const cardBIN = this.payerData.creditCardNumber.substring(0, 6);
        let result = { IsAuthenticated: false, ThreeDSCode: "", Errors: "" };

        console.group('iatsGetFingerPrint');
        console.log('Started');
        console.info('CardBIN: ' + cardBIN);
        console.info('ClientID: ' + this.clientID);

        if (!this.iats3ds) {
            return undefined;
        }

        return iats3ds.iatsGetFingerPrintId(this.clientID, cardBIN).then((response) => {
            
            switch (response.success) {
            case true: {
                    if (response.deviceFingerPrint == "") {
                        //complete: no further authentication required.
                        console.log("Success, no further authentication required");
                        result.IsAuthenticated = true;

                    } else {
                        //requires action: proceed to 3DS Authentication Validation(deviceFingerPrint will be needed)
                        console.log("Device fingerprint required");
                        console.info("DeviceFingerPrint: " + response.deviceFingerPrint);
                        console.groupEnd();
                        result = this.authenticateCustomer(response.deviceFingerPrint, result);
                    }
                    break;
                }
                default: { 
                    //error: check the errorMessage property for failure message
                    if (response.errorMessage) {
                        console.error(response.errorMessage);
                        if (response.errorMessage.includes("cardBin")) {
                            result.Errors = "Invalid card number.";
                        } else {
                            result.Errors = response.errorMessage;
                        }
                    } else {
                        console.error("FAILED");
                        result.Errors = "3DS failed for an unknown reason.";
                    }

                    console.groupEnd();
                    break;
                }
            }

            return result;
        });
    }

    //
    // Step 2: 
    // Authenticate Customer (Conditional)
    //
    authenticateCustomer(deviceFingerPrintId, result) {

        const parameters = {
            'deviceFingerPrintId': deviceFingerPrintId,
            'agentId':             this.clientID,
            'creditCardNum':       this.payerData.creditCardNumber,
            'creditCardExpiry':    this.payerData.creditCardExpiry,
            'total':               this.payerData.total,
            'firstName':           this.payerData.firstName,
            'lastName':            this.payerData.lastName,
            'address':             this.payerData.addressLine1,
            'city':                this.payerData.city,
            'state':               this.payerData.countrySubEntity,
            'zipCode':             this.payerData.zipCode,
            'country':             this.payerData.country
        };

        const request = { method: 'POST', body: new window.URLSearchParams(parameters) };

        return fetch(Iats3dsController.endpoint, request).then(response => response.text()).then(xml => {
            try
            {
                let json = JSON.parse(new DOMParser().parseFromString(xml, 'text/xml').childNodes[0].innerHTML);
                switch (json.status)
                {
                    case 'COMPLETED':
                        //complete: 'AuthenticationCode3DS' is required to complete the transaction.
                        console.log('Success');
                        console.info('3DS: ' + json.id);
                        result.ThreeDSCode = json.id;
                        result.IsAuthenticated = true;
                        break;
                    case 'PENDING':
                        //requires action: challenge has been requested.
                        console.log('Pending, challenge is required');
                        console.info(json.sdkChallengePayload);
                        console.groupEnd();
                        result = this.createChallenge(json.sdkChallengePayload, result);
                        break;
                    default:
                        //error: the transaction has failed the validation step and cannot proceed.                                                        
                        if (json.error.fieldErrors) {
                            json.error.fieldErrors.forEach(error => {
                                let msg = error.field + ': ' + error.error;
                                result.Errors += msg + '#';
                                console.error(msg);
                            });
                            result.Errors = result.Errors.substring(0, result.Errors.length - 1);
                        } else
                        if (json.error.message) {
                            console.error(json.error.message);
                            result.Errors = json.error.message;
                        } else {
                            console.error('FAILED');
                            result.Errors = '3DS failed for an unknown reason.';
                        }
                        console.groupEnd();
                        break;
                }
                return result;
            } catch (error) {
                console.error(error.errorMessage);
                console.groupEnd();
            }
            return null;
        });
    }

    createChallenge(sdkChallengePayload, result) {
        result.Challenge = {
            clientID: this.clientID,
            isAuthenticated: false,
            sdkChallengePayload: sdkChallengePayload,          
            threeDSCode: "",        
            errors: ""
        };
        return result;
    }

    validate() {
        return this.payerData.validate();
    }
}